import React from "react";
import KeywordTag from "../../keywords";
import ViewDetailsButton from "@/src/components/button/Jobs/ViewDetailsButton";
import JobHeader from "../../section-heading/JobHeader";
import ApplyButton from "../../button/Jobs/ApplyButton";

export interface JobCardProps {
  jobTitle: string;
  description: string;
  keyWords: string[];
  jobId: string;
  jobType?: string;
  isAvailable?: boolean;
  postDate?: string;
  IsRequesterPreviouslyApplied: boolean;
}

const JobCard: React.FC<JobCardProps> = ({
  jobTitle,
  description,
  keyWords,
  jobId,
  isAvailable = true,
  postDate,
  IsRequesterPreviouslyApplied
}) => {
  const lang =
  typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "";
const isArabic = lang === "ar";
  return (
    <div dir="ltr" className="sm:w-[411px] w-full min-h-[411px]  p-4 bg-white dark:bg-accent-700 rounded-xl shadow flex-col justify-center items-end gap-6 inline-flex">
      <div className="self-stretch flex-col justify-start items-end gap-4 flex">
        <JobHeader 
          jobTitle={jobTitle} 
          jobId={jobId}
          isAvailable={isAvailable}
          postDate={postDate || "N/A"}
        />

        <div className="self-stretch flex-col justify-start items-end gap-2 flex">
          <div className="self-stretch text-start text-[#414c5d] text-base font-semibold leading-snug dark:text-gray-300">
            {
              isArabic ?
                "ملخص الوظيفة:" :
                "Position Summary:"
            }
          </div>
          <div className="self-stretch text-start text-[#414c5d] text-sm font-normal leading-tight dark:text-gray-400 h-[80px] overflow-hidden">
            {description.split(' ').length > 29 ? description.split(' ').slice(0, 30).join(' ') + '...' : description}
          </div>
        </div>

        <div className="justify-start items-center gap-2 inline-flex">
          <KeywordTag keywords={keyWords} />
        </div>
      </div>

      <div className="self-stretch flex justify-between w-full gap-x-4">
        <div className="w-1/2">
          <ViewDetailsButton jobId={jobId} />
        </div>
        <div className="w-1/2">
         <ApplyButton IsRequesterPreviouslyApplied={IsRequesterPreviouslyApplied} jobId={jobId} />
        </div>
      </div>
    </div>
  );
};

export default JobCard;